// extracted by mini-css-extract-plugin
export default {"statusWrap":"Status_statusWrap__+1zzb","statusText":"Status_statusText__CfX3A"};